(() => {
  'use strict';
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  // This helper is only for the ten Discover-by-World collection pages.
  // Form/atelier pages own their own fullscreen state and must not be mutated here.
  const match = location.pathname.match(/^\/collections\/([^/?#]+)/);
  const handle = match ? decodeURIComponent(match[1]) : '';
  const worlds = new Set([
    'autumn-whisper','blossom-wood','daisy-dream','garden-grey','golden-flora',
    'mystic-garden','olive-waves','petal-eden','pink-paradise','violet-valley'
  ]);
  if (!worlds.has(handle)) return;

  const repair = () => {
    const html = document.documentElement;
    const body = document.body;
    if (!body) return;
    html.classList.remove('m:overflow-hidden', 'pf-mobile-world-is-flying');
    body.classList.remove('m:overflow-hidden', 'is-transitioning', 'pf-mobile-world-is-flying');
    document.querySelectorAll('.pf-mobile-world-flight').forEach((node) => node.remove());
    const fader = document.querySelector('.m-page-transition');
    if (fader) {
      fader.classList.remove('fade-in');
      fader.classList.add('fade-out');
    }
  };

  window.addEventListener('pageshow', repair, { passive: true });
  repair();
})();
